import type {ReactElement} from 'react';
import React from 'react';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import { ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {ColorFillPropertyType} from '@Components/color-fill';
import type {FillObject} from '@PosterWhiteboard/classes/fill.class';
import { FillTypes} from '@PosterWhiteboard/classes/fill.class';

interface BaseTextColorOptionProps {
  fillObject: FillObject;
  onClickColorFill(): void;
  isDisabled?: boolean;
}

export function BaseTextColorOption({isDisabled = false, ...props}: BaseTextColorOptionProps): ReactElement | null {
  const getFillType = (): ColorFillPropertyType => {
    if (props.fillObject.fillType === FillTypes.LINEAR_GRADIENT) {
      return ColorFillPropertyType.LINEAR;
    }

    if (props.fillObject.fillType === FillTypes.RADIAL_GRADIENT) {
      return ColorFillPropertyType.RADIAL;
    }

    return ColorFillPropertyType.SOLID;
  };

  const getTextColorData = (): Array<ColorFillStorage> => {
    return [
      {
        id: 'text-color-object',
        fillType: getFillType(),
        color: getColorObjectArrayFromFillColor(props.fillObject.fillColor),
      },
    ];
  };

  return (
    <ContextualMenuColorFillOption
      isDisabled={isDisabled}
      id="text-color-option"
      label={window.i18next.t('pmwjs_color')}
      data={getTextColorData()}
      onClick={(): void => {
        props.onClickColorFill();
      }}
    />
  );
}
